module.exports = __webpack_public_path__ + "static/media/careemLogoBlack.b785535b.svg";